// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d82da1b0","457":"dd1e961c","548":"98500119","551":"171b575f","629":"cabecc2b","796":"c7381681","815":"d917822b","851":"823869ab","950":"fc1e1398"}[chunkId] + ".chunk.js";
};